

import templateLogoImg from '@/app-template/lib/components/LogoImg.vue';

export default {
  components: { templateLogoImg },
};
